// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Vuu7e","nav":"index_nav_wnfM9","navTitle":"index_navTitle_-GwVg"};